// export this package's api
import Rate from './src/';
export default Rate;



// WEBPACK FOOTER //
// ./_rc-rate-1.1.2/index.js